import React from 'react'
import { Button } from '@/design-system'
import type { DsButtonSize } from '@/design-system'

export interface TurnTo3dCtaProps {
  onClick?: () => void
  disabled?: boolean
  /** Hide until Phase 2 / feature flag */
  visible?: boolean
  /** Icon-only, no label — for narrow top bars */
  compact?: boolean
  size?: DsButtonSize
}

/** Primary album CTA — parent routes to `/albums/:id/to-3d` or an existing gallery studio. */
export function TurnTo3dCta({ onClick, disabled, visible = true, compact, size = 'md' }: TurnTo3dCtaProps) {
  if (!visible) return null
  return (
    <Button
      variant='primary'
      size={size}
      onClick={onClick}
      disabled={disabled}
      aria-label='Turn into 3D'
      sx={{
        letterSpacing: '-0.01em',
        px: compact ? 0 : undefined,
        minWidth: compact ? (size === 'sm' ? 34 : 40) : undefined,
        width: compact ? (size === 'sm' ? 34 : 40) : undefined,
        flexShrink: 0,
      }}
    >
      {compact ? '◈' : '◈ Turn into 3D'}
    </Button>
  )
}
